<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
      <!-- <b-card-text>Privilege.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Category -->
            <b-col cols="12">
              <b-form-group label="Category" label-for="v-category">
                <validation-provider #default="{ errors }"  name="Category" rules="required">
                  <v-select id="v-category" v-model="form.select_1" placeholder="Chose Category" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="CategoryOptions" :reduce="CategoryOptions => CategoryOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Code -->
            <b-col cols="12">
              <b-form-group label="Code" label-for="v-product-code">
                <validation-provider #default="{ errors }" name="Code" rules="required" >
                  <v-select
                    id="v-product-code"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="AccessOptions"
                    :reduce="(AccessOptions) => AccessOptions.value"
                    label="title"
                    multiple
                    clearable
                    v-model="form.text_2"
                    placeholder="Access"
                    class="w-100"
                  />
                  <!-- <b-form-input id="v-product-code" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Code" /> -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group label="Name" label-for="v-product-name">
                <validation-provider #default="{ errors }" name="Name" rules="required">
                  <v-select
                    id="v-product-name"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="NameOptions"
                    :reduce="(NameOptions) => NameOptions.value"
                    label="title"
                    v-model="form.text_3"
                    placeholder="Name"
                    class="w-100"
                  />
                  <!-- <b-form-input  :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Name" /> -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Icon -->
            <!-- <b-col cols="12">
              <b-form-group label="Icon" label-for="v-product-icon">
                <validation-provider #default="{ errors }" name="Icon">
                  <b-form-input id="v-product-icon" :state="errors.length > 0 ? false:null" v-model="form.text_4" placeholder="Icon"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- Slug -->
            <!-- <b-col cols="12">
              <b-form-group label="Slug" label-for="v-product-slug">
                <validation-provider #default="{ errors }" name="Slug" >
                  <b-form-input id="v-product-icon" :state="errors.length > 0 ? false:null" v-model="form.text_5" placeholder="Slug"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- Url -->
            <!-- <b-col cols="12">
              <b-form-group label="Url" label-for="v-product-url">
                <validation-provider #default="{ errors }" name="Url">
                  <b-form-input id="v-product-url" :state="errors.length > 0 ? false:null" v-model="form.text_6" placeholder="Url"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '',text_2: '',text_3: ''},
      show: false,
      NameOptions: [
        { title: 'UI', value: 'UI' },
        { title: 'IC', value: 'IC' }
      ],
      AccessOptions: [
        { title: 'Create', value: 'C' },
        { title: 'Read', value: 'R' },
        { title: 'Update', value: 'U' },
        { title: 'Delete', value: 'D' }
      ],
      required 
    }
  },
  computed: {
    ...mapState({ CategoryOptions: state => state.privilegeCategory.options}),
  },
  created () {
    this.$store.dispatch('privilegeCategory/getAll')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = {...this.form, text_2: this.form.text_2.join("")}
			    this.$store.dispatch('privilege/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('privilege/getById', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.privilege_category_id
        this.form.text_2 = data.name.split("")
        this.form.text_3 = data.code
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>